var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',[_c('icon',[_c('ship',{attrs:{"transform":"translate(16 -6) scale(1)"}}),_c('ship',{attrs:{"transform":"translate(6 0) scale(1.5)"}}),_c('ship',{attrs:{"transform":"translate(-8 8) scale(2)"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }